<template>
	<Modal
		v-if="visible"
		close-button-absolute
		remove-padding
		max-width="sm:max-w-[485px]"
		@modal:close="$emit('close')"
	>
		<template #body>
			<div class="flex flex-col items-center">
				<div class="flex h-32 w-full items-center justify-center bg-[#e0f2fe]">
					<img
						:src="image"
						class="h-12"
						:alt="title"
					/>
				</div>

				<div class="mt-6 px-6 text-center">
					<div class="font-Inter text-2xl font-semibold text-[#111827]">
						{{ title }}
					</div>
					<div class="mx-2 mt-2.5 font-Inter text-sm font-normal text-[#6b7280]">
						{{ body }}
					</div>
				</div>
			</div>
		</template>

		<template #actions>
			<Button
				class="mt-2.5 w-full justify-center font-[Roboto] font-medium"
				variant="primary"
				size="big"
				@click="$emit('begin')"
			>
				{{ ctaLabel }}
			</Button>
		</template>
	</Modal>
</template>

<script setup>
import Modal from '../modal.vue';
import Button from '../library/button.vue';

// Reusable entry-point modal for a guided tutorial: "Welcome to ResumAI!" for new users today
// (EN-805), and reusable as-is for EN-806's "what's new" re-introduction to existing users —
// only title/body/cta copy differ between the two.
defineProps({
	visible: { type: Boolean, default: false },
	title: { type: String, default: 'Welcome to ResumAI!' },
	body: { type: String, default: '' },
	image: { type: String, default: '/img/resumai-logo.png' },
	ctaLabel: { type: String, default: 'Begin' },
});

defineEmits(['begin', 'close']);
</script>
